
import { Vue } from "vue-class-component";

export default class ShopifyActive extends Vue {}
